// extracted by mini-css-extract-plugin
module.exports = {"link":"instagram-link-module--link--iH0KM"};